// Chakra imports
import {
    Button,
    Flex,
    HStack,
    Table,
    Tbody,
    Text,
    Th,
    Thead,
    Tr,
    useColorModeValue,
    useDisclosure,
    useToast,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import React, {useEffect, useState} from "react";
import NoticeTableRow from "./NoticeTableRow";
import AddNoticeModal from "./AddNoticeModal";
import DeleteNoticeModal from "./DeleteNoticeModal";
import {saveNotice, searchNotice} from "./Services";

const Notice = ({title, captions, data}) => {

    const toast = useToast();

    const textColor = useColorModeValue("gray.700", "white");
    const {isOpen, onOpen, onClose} = useDisclosure(); // Modal state management
    const [noticeList, setNoticeList] = useState("");
    const [noticeDetail, setNoticeDetail] = useState(null);
    const [noticeId, setNoticeId] = useState(null);

    const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
    const [isBlockNoticeModal, setIsBlockNoticeModal] = useState(false);
    const [isDetailModal, setDetailModal] = useState(false);

    useEffect(() => {
        fetchNoticeList();
    }, []);

    const fetchNoticeList = async () => {

        try {
            let request = {
                schoolId: null,
                name: ""
            }
            const response = await searchNotice(request, 1, 10);
            if (response.status === 200) {
                const {noticeList} = response.data
                setNoticeList(noticeList);
            }
        } catch (e) {
            console.error("Error while fetching notice list e:", e);
        }
    }

    const handleNoticeSubmit = async (noticeDetails) => {

        let request = {
            schoolId: Number(noticeDetails.schoolId),
            fullName: noticeDetails.fullName,
            address: noticeDetails.address,
            email: noticeDetails.email,
            password: noticeDetails.password,
            mobileNumber: noticeDetails.phone,
            designation: noticeDetails.designation,
            description: noticeDetails.description
        }

        try {
            const response = await saveNotice(request);
            console.log(response)
            console.log(response)
            if (response.status === 201) {
                toast({
                    title: "Success!",
                    description: "Notice details saved successfully.",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                });
                onClose();
                fetchNoticeList();
            }

        } catch (e) {
            console.error("Error while submiting notice details e:", e);
        }
    }

    const handleNoticeBlock = async (id, remarks) => {
        let request = {
            noticeId: id,
            remarks: remarks.trim(),
        }
        try {
            const response = await blockNotice(request);
            if (response.status === 200) {
                toast({
                    title: "Success!",
                    description: "Notice Blocked successfully.",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                });
                setIsBlockNoticeModal(false);
                fetchNoticeList();
            }
        } catch (e) {
            console.error("Error while submiting notice details e:", e);
        }
    }


    const handeNoticeUpload = () => {
    }

    const handleApproveModalOpen = () => {
        setIsApproveModalOpen(true);
    }
    const handleApproveModalClose = () => {
        setIsApproveModalOpen(false);
    }

    const handleBlockNoticeModal = (notice, flag) => {
        if (flag === true) {
            setNoticeId(notice.id)
        }
        setIsBlockNoticeModal(flag);
    }

    const handleNoticeDetailModal = async (notice, flag) => {

        if (flag === true) {
            try {
                let request = {
                    noticeId: Number(notice.id),
                }

                const response = await fetchNoticeDetail(request);
                if (response.status === 200) {
                    setNoticeDetail(response.data)
                }

            } catch (e) {
                console.error("Error while trying to handle notice approval :{}", e);
            }
        }
        setDetailModal(flag);
    }

    const handleApproveConfirm = async (notice) => {
        try {
            let request = {
                noticeId: Number(notice.id),
                remarks: "Notice Approved"
            }

            const response = await approveNotice(request);
            if (response.status === 200) {
                toast({
                    title: "Success!",
                    description: "Notice approval saved successfully.",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                });
                setIsApproveModalOpen(false);
                fetchNoticeList();
            }

        } catch (e) {
            console.error("Error while trying to handle notice approval :{}", e);
        }
    }

    return (
        <Card overflowX={{sm: "scroll", xl: "hidden"}}>
            <CardHeader p="16px 0 24px 0">
                <Flex justify="space-between" align="center" wrap="wrap" gap="12px">
                    {/* Title on the left */}
                    <Text fontSize="lg" color={textColor} fontWeight="semibold" flex="1" isTruncated>
                        {title}
                    </Text>

                    {/* Buttons on the right */}
                    <HStack spacing="3" wrap="wrap">
                        <Button colorScheme="blue" size="sm" onClick={onOpen}>
                            Add Notice
                        </Button>
                    </HStack>
                </Flex>
            </CardHeader>

            <CardBody>
                <Table variant='simple' color={textColor}>
                    <Thead>
                        <Tr my='.8rem' pl='0px' color='gray.400'>
                            {captions.map((caption, idx) => {
                                return (
                                    <Th color='gray.400' key={idx} ps={idx === 0 ? "0px" : null}>
                                        {caption}
                                    </Th>
                                );
                            })}
                        </Tr>
                    </Thead>
                    <Tbody>
                        <>
                            {isOpen ?
                                <AddNoticeModal
                                    isOpen={isOpen}
                                    onClose={onClose}
                                    handeNoticeUpload={handeNoticeUpload}
                                    handleNoticeSubmit={handleNoticeSubmit}
                                /> : ""
                            }
                            {isBlockNoticeModal ?
                                <DeleteNoticeModal
                                    isOpen={isBlockNoticeModal}
                                    handleBlockNoticeModal={handleBlockNoticeModal}
                                    handleNoticeBlock={handleNoticeBlock}
                                    noticeId={noticeId}
                                /> : ""
                            }

                            {/*{isDetailModal ?*/}
                            {/*    <NoticeDetailModal*/}
                            {/*        isOpen={isDetailModal}*/}
                            {/*        handleNoticeDetailModal={handleNoticeDetailModal}*/}
                            {/*        onClose={handleNoticeDetailModal}*/}
                            {/*        noticeDetails={noticeDetail}*/}
                            {/*    /> : ""*/}
                            {/*}*/}
                            {noticeList && noticeList.map((notice,index) => {
                                return (
                                    <NoticeTableRow
                                        sn={index+1}
                                        notice={notice}
                                        isApproveModalOpen={isApproveModalOpen}
                                        handleApproveModalClose={handleApproveModalClose}
                                        handleApproveModalOpen={handleApproveModalOpen}
                                        handleApproveConfirm={handleApproveConfirm}
                                        handleBlockNoticeModal={handleBlockNoticeModal}
                                        handleNoticeDetailModal={handleNoticeDetailModal}
                                    />
                                );
                            })}
                        </>
                    </Tbody>
                </Table>
            </CardBody>
        </Card>
    );
};

export default Notice;
